<template>
  <div class="col-sm-12">
    <div class="col-sm-12 editor-form" @click.stop="">
      <h2 class="editor-header">{{ $t('relationships.add') }}</h2>
      <div class="col-sm-12 nopads">
          <span class="span-title">
              {{ $t('relationships.customer') }}
          </span>
          <select
              id="customer"
              v-model="customer"
              class="form-select form-select-sm mb-3"
              :disabled="!companies || companies.length < 1"
          >
              <option :value="null" disabled>
                  {{ $t('relationships.select_customer') }}
              </option>
              <option v-for="c in companies" :key="c.id" :value="c.id">
                  {{ c.name }}
              </option>
          </select>

          <span class="span-title">
              {{ $t('relationships.contractor') }}
          </span>
          <select
              id="contractor"
              v-model="contractor"
              class="form-select form-select-sm mb-3"
              :disabled="!companies || companies.length < 1"
          >
              <option :value="null" disabled>
                  {{ $t('relationships.select_contractor') }}
              </option>
              <option v-for="com in companies" :key="com.id" :value="com.id">
                  {{ com.name }}
              </option>
          </select>
      </div>
      <div class="col-sm-12 button-container">
        <button
          class="btn btn-secondary form-button"
          @click.stop="$emit('close')"
        >
            {{ $t('common.cancel') }}
        </button>
        <button
          class="btn btn-success form-button"
          :disabled="loading"
          @click.stop="submitRelationship"
        >
            {{ $t('common.save') }}
        </button>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {workManagementHelper} from '../../mixins/WorkManagementMixin'
import {inject} from "vue";

export default {
    name: 'CompanyRelationshipEditor',
    mixins: [workManagementHelper, restApi],
    props: {
        company: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            companies: [],
            customer: null,
            contractor: null
        }
    },

    mounted: function () {
        this.fetchCompanies()
    },

    methods: {

        fetchCompanies: function () {
            this.loading = true
            this.restFetch(this.companyUrl, this.handleCompanies)
        },

        handleCompanies: function (response) {
            this.companies = response.data
            this.loading = false
        },

        submitRelationship: function () {
            if (this.customer && this.contractor) {
                var relationship = {customer: this.customer, contractor: this.contractor}
                this.loading = true
                this.restAdd(this.companyRelationshipUrl, relationship, this.success, this.fail)
            } else {
                this.showAlert(this.$t('relationships.err_select_both'))
            }
        },

        success: function () {
            this.$emit('close')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }
    }
}
</script>
